import React from "react";
import { useLocation } from "react-router-dom";

import { heroBgStyle } from "../../lib/siteImages";

const SiteBackground = () => {
  const { pathname } = useLocation();

  if (pathname.startsWith("/assessment/") || pathname.startsWith("/profile/")) return null;

  return (
    <div className="fixed inset-0 -z-10 pointer-events-none" aria-hidden="true">
      <div className="landing-hero-bg" style={heroBgStyle} />
    </div>
  );
};

export default SiteBackground;
